import { render, staticRenderFns } from "./turnstile.vue?vue&type=template&id=241387d9&scoped=true&"
import script from "./turnstile.component.ts?vue&type=script&lang=ts&"
export * from "./turnstile.component.ts?vue&type=script&lang=ts&"
import style0 from "./turnstile.scss?vue&type=style&index=0&id=241387d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241387d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('241387d9')) {
      api.createRecord('241387d9', component.options)
    } else {
      api.reload('241387d9', component.options)
    }
    module.hot.accept("./turnstile.vue?vue&type=template&id=241387d9&scoped=true&", function () {
      api.rerender('241387d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/turnstile/turnstile.vue"
export default component.exports